function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6,
  y: 1,
  width: 25,
  height: 23,
  rx: 2,
  stroke: "#1A6E9D",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5162e-05 9.24589L9.48538e-05 16.2958L8.53128 16.2958L8.53128 20.9957L16.9697 12.7708L8.53128 4.54596L8.53128 9.24589L9.5162e-05 9.24589Z",
  fill: "#1A6E9D"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 12.5L10.4799 16L10.4799 14.1129L2 14.1129L2 10.8871L10.4799 10.8871L10.4799 9L14 12.5Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 21,
  cy: 9,
  r: 3,
  stroke: "#1A6E9D",
  strokeWidth: 2
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 21C14 19 15.4 15 21 15C26.6 15 28 19 28 21",
  stroke: "#1A6E9D",
  strokeWidth: 2
});

var SvgMandate = function SvgMandate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMandate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mandate.16b0f191.svg";
export { ForwardRef as ReactComponent };